var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfollowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2031 11.0577V16.8687H3.70312C3.70312 13.5549 6.38941 10.8687 9.70312 10.8687C10.2211 10.8687 10.7237 10.9343 11.2031 11.0577ZM9.70312 10.1187C7.21688 10.1187 5.20312 8.1049 5.20312 5.61865C5.20312 3.1324 7.21688 1.11865 9.70312 1.11865C12.1894 1.11865 14.2031 3.1324 14.2031 5.61865C14.2031 8.1049 12.1894 10.1187 9.70312 10.1187ZM14.9531 12.808L16.5441 11.217L17.6047 12.2777L16.0138 13.8687L17.6047 15.4596L16.5441 16.5203L14.9531 14.9293L13.3622 16.5203L12.3015 15.4596L13.8925 13.8687L12.3015 12.2777L13.3622 11.217L14.9531 12.808Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollowIcon);
export default __webpack_public_path__ + "static/media/UnfollowIcon.807b09510c8e48d7ec1c4f39f22f0731.svg";
export { ForwardRef as ReactComponent };